import { AnyAction, MiddlewareAPI, Middleware } from 'redux';
import { ReduxState } from 'types/redux';
import notification from 'handlers/notification/notificationActionCreator';
import getMessage, { MessageType } from 'constants/messages';
import { ApplicationNotesActionType } from './ActionTypes';
import { getApplicationNotes, AddApplicationNoteSuccessAction, closeApplicationNotePopup } from './ActionCreator';

const isAddApplicationNoteSuccessAction = (action: AnyAction): action is AddApplicationNoteSuccessAction =>
  action.type === ApplicationNotesActionType.AddApplicationNoteSuccess;

export const AddApplicationNotesSuccessMiddlewares = (({ dispatch, getState }: MiddlewareAPI<ReduxState>) => (
  next: (action: AnyAction) => any,
) => (action: AnyAction) => {
  const result = next(action);

  if (isAddApplicationNoteSuccessAction(action)) {
    const { loanOriginationSystemApplicationPage } = getState();

    const { notes, applicationData } = loanOriginationSystemApplicationPage;

    if (!applicationData) {
      return result;
    }
    notification.createNotification(getMessage(MessageType.ApplicationNoteAdded), 'success', dispatch);

    dispatch(getApplicationNotes(applicationData.id, notes.search, notes.sortingType));
    dispatch(closeApplicationNotePopup());
  }

  return result;
}) as Middleware;
